module.exports = __webpack_public_path__ + "img/mtt_4.8.2ea7f2d9.png";